<template lang="pug">
.col-8_xs-12
  .hero.youtube(v-if="youtubeVideo" v-html="youtubeVideo")
  .hero.vimeo(v-else-if="vimeoVideo" v-html="vimeoVideo")
  .hero(v-else)
    img.cover(:src="image.url" :alt="captions")
  p.heroCaptions.body-captions(v-if="captions" v-html="captions")
</template>

<script>

export default {
  name: 'hero',
  props: ['youtube', 'vimeo', 'image', 'captions'],

  computed: {
    youtubeVideo: function () {
      return this.youtube ? `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${this.youtube}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` : false
    },

    vimeoVideo: function () {
      return this.vimeo !== '' ? this.vimeo : false
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../styles/_mixins'
.hero
  width: 100%
  height: 47.5vw
  @include respond-to(xs)
    height: 72vw
  &.youtube
    height: 34vw
    @include respond-to(xs)
      height: 52vw
  &.vimeo
    height: unset !important
.heroCaptions
  margin-top: 1rem
  color: #939598
</style>



// WEBPACK FOOTER //
// Hero.vue?d0232d34